import { Token } from "@/pages/create-fund/components/select-tokens/select-tokens";
import { formatImageLink } from "@/api/helpers/helper";

const API_URL = import.meta.env.VITE_API_URL || "http://localhost:8000";

const tokenListQuery = `${API_URL}/tokens`;
const createFundEndpoint = `${API_URL}/create-fund`;

const options: RequestInit = {
  method: "GET",
  mode: "cors",
  headers: {
    "Content-Type": "application/json",
  },
};
// Helper to decode hex to string
const hexToString = (hex: string): string => {
  try {
    let str = '';
    for (let i = 0; i < hex.length; i += 2) {
      str += String.fromCharCode(parseInt(hex.substr(i, 2), 16));
    }
    return str;
  } catch (e) {
    return hex;
  }
};

export const fetchTokenList = async (): Promise<Token[]> => {
  try {
    const res = await fetch(tokenListQuery, options);
    const data: Record<string, number> = await res.json();

    // Convert the response object to Token array
    return Object.keys(data).map((tokenId) => {
      // The tokenId is hex-encoded: PolicyID (56 hex chars) + AssetName (remaining hex chars)
      // Extract only the asset name part (after the first 56 characters)
      const assetNameHex = tokenId.substring(56);
      const decodedName = hexToString(assetNameHex);

      return {
        policy_id: tokenId,
        token_name: decodedName,
        token_symbol: decodedName, // Use full decoded name as symbol
        token_decimal_places: 0,
        token_image: "",
      };
    });
  } catch (e) {
    console.error("API FetchTokens ERROR::", e);
    return [];
  }
};

interface CreateFundParams {
  fundName: string;
  tokens: string[];
  tokenFactors: number[];
  fundFactor: number;
  royaltyFactor: number;
  creatorPkh: string | null;
  userAddress: string;
}

interface CreateFundResponse {
  cbor: string;
}

export const createFund = async (params: CreateFundParams): Promise<string> => {
  try {
    // Backend expects address as query param (matching create-fund.sh)
    const url = `${createFundEndpoint}?address=${encodeURIComponent(params.userAddress)}`;

    const body = {
      fund: {
        tokens: params.tokens,
        token_factors: params.tokenFactors,
        fund_factor: params.fundFactor,
        royalty_factor: params.royaltyFactor,
        creator_pkh: params.creatorPkh,
        fund_name: params.fundName,
      },
      user_address: params.userAddress,
    };

    console.log("Sending to backend:", { url, body });

    const res = await fetch(url, {
      method: "POST",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });

    if (!res.ok) {
      const errorText = await res.text();
      console.error("Backend error response:", errorText);
      throw new Error(`Backend error: ${res.status} ${res.statusText} - ${errorText}`);
    }

    const data: CreateFundResponse = await res.json();
    return data.cbor;
  } catch (e) {
    console.error("API createFund ERROR::", e);
    throw e;
  }
};
